export default () => {

  const $progressBar = $('.header progress');

  // Update progress bar on scroll
  $(window).on('scroll', () => {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop,
          height = document.documentElement.scrollHeight - document.documentElement.clientHeight,
          scrolled = (winScroll / height) * 100
    ;
    $progressBar.prop('value', scrolled);
  });

};
